import { Grid } from "@material-ui/core";
import "./styles.scss";

type PageLabelProps = {
  label: string;
  children: React.ReactNode;
};
const PageLabel = ({ label, children }: PageLabelProps) => (
  <Grid className="pageLabel" container justifyContent="space-between" alignItems="center" wrap="nowrap">
    <p>{label}</p>
    {children}
  </Grid>
);

export default PageLabel;
